<template>
    <b-navbar toggleable="md" :sticky="true" class="top-bar">
        <b-navbar-brand>
            <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex" height="40px"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto bar-right">
                <div>
                    <button class="btn-grad mx-auto py-2 px-4" @click="scrollToElement('contactElement')" >Schedule a Demo</button>
                </div>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import {GlobalRouteNames} from "../../routeNames";

export default {
    computed: {
        GlobalRouteNames() {
            return GlobalRouteNames
        },
        currentRoute() {
            return this.$route.name;
        }
    },
    methods: {
        scrollToElement(ref) {
            this.$emit('scrollToTarget', ref);
        },
        isActive(routeName) {
            return false;
        }
    },

};


</script>

